import React from "react"
import { Box } from "@mui/material"
import { ButtonLoadingSeeker, IconSeeker } from "@ui-seeker/core"
import { autoEuropePricingIdDrawerData, autoEuropePricingIdDrawerErrors, clearAutoEuropePricingIdSignals } from "Pages/AutoEuropeTool/PricingId/@signals"

export default function AutoEuropePricingIdFooter({ onSubmit, isLoading }) {
	return <Box>
		<ButtonLoadingSeeker
			sx={{ m: 1 }}
			startIcon={<IconSeeker icon="circle-left" tooltip="Cancel"/>}
			onClick={clearAutoEuropePricingIdSignals}
			variant="outlined"
		>
			Cancel
		</ButtonLoadingSeeker>
		<ButtonLoadingSeeker
			sx={{ m: 1 }}
			loading={isLoading}
			startIcon={<IconSeeker icon="floppy-disk" tooltip="Save"/>}
			disabled={!Object.values(autoEuropePricingIdDrawerErrors.value).every(a => a)}
			onClick={() => onSubmit(autoEuropePricingIdDrawerData.value)}
		>
			Save
		</ButtonLoadingSeeker>
	</Box>
}